// extracted by mini-css-extract-plugin
module.exports = {"headerFile":"SendMessageHeaderFile_headerFile__2J4fN","header":"SendMessageHeaderFile_header__2PLLE"};